export class Coord {
  constructor(obj) {
    const lat = obj.latitude || obj.lat;
    const lng = obj.longitude || obj.lng;

    // Validate that coordinates are finite numbers to address downstream
    // error when trying to pass undefined coordinates to Google Maps
    this.lat = Number.isFinite(lat) ? lat : null;
    this.lng = Number.isFinite(lng) ? lng : null;
  }
}
